"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.TaskProjectSearchResult = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var use_on_click_index_1 = require("@hiyllo/ux/use-on-click-index");
var common_1 = require("../common");
var keyboard_hint_1 = require("../keyboard-hint");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_native_1 = require("react-native");
exports.TaskProjectSearchResult = react_1["default"].memo(function TaskProjectSearchResult(props) {
    var onClick = react_1["default"].useCallback(function () {
        props.onUpdateResults([
            {
                type: 'tasks/project/kanban',
                project: props.result.project
            },
            {
                type: 'tasks/project-planning',
                project: props.result.project
            },
            {
                type: 'tasks/project/create-task',
                project: props.result.project
            },
        ]);
    }, [props]);
    (0, use_on_click_index_1.useOnClickIndex)(onClick, props.index);
    return ((0, jsx_runtime_1.jsxs)(common_1.SearchResultContainer, __assign({ onPress: onClick }, { children: [(0, jsx_runtime_1.jsx)(keyboard_hint_1.SearchResultKeyboardHint, { showTabHint: true, value: (props.index + 1).toString() }), (0, jsx_runtime_1.jsx)(common_1.SearchResultText, { children: props.result.project.name }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 15 } }), (0, jsx_runtime_1.jsx)(common_1.SearchResultAppLabel, { icon: pro_light_svg_icons_1.faSquareKanban, title: "Project (Tasks)" })] })));
});
